import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const PYQCuetPage = () => {
  const [gateOpen, setGateOpen] = useState(false);
  const [pending, setPending] = useState('');
  const [form, setForm] = useState({ name: '', email: '', phone: '' });

  const openGate = (which) => { setPending(which); setGateOpen(true); };
  const handleSubmit = (e) => {
    e.preventDefault();
    setGateOpen(false);
    alert(`Thank you! Your ${pending} download link has been sent to ${form.email}.`);
  };

  const faqs = [
    { q: 'Are CUET PYQs free to download?', a: 'Yes, basic access is free after a quick registration.' },
    { q: 'Are these PYQs based on latest exams?', a: 'Yes, we provide updated and relevant question papers from recent CUET exams.' },
    { q: 'Do I need to register to download?', a: 'Yes, quick registration is required to access the download links.' },
    { q: 'Are PYQs available for all subjects?', a: 'Yes, for both CUET UG (all subjects) and CUET PG (domain-wise).' },
    { q: 'How should I use PYQs for preparation?', a: 'Practice regularly, analyze question patterns, and identify high-weightage topics.' },
  ];

  return (
    <>
      <Helmet>
        <title>PYQ of CUET UG & PG | Download Previous Year Question Papers PDF</title>
        <meta name="description" content="Download PYQ of CUET UG & PG in PDF format. Get previous year question papers, understand exam pattern & boost your preparation." />
        <meta name="keywords" content="PYQ of CUET, CUET previous year question papers, CUET UG PYQ, CUET PG PYQ, CUET question paper PDF" />
        <link rel="canonical" href="https://besst.in/pyq-cuet" />
        <meta property="og:title" content="PYQ of CUET UG & PG | Download Previous Year Question Papers PDF" />
        <meta property="og:description" content="Download PYQ of CUET UG & PG in PDF format. Get previous year question papers and understand exam pattern." />
        <meta property="og:url" content="https://besst.in/pyq-cuet" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="BESST" />
      </Helmet>
      <div className="min-h-screen pt-32 pb-20">
        {/* Hero */}
        <div className="max-w-[1400px] mx-auto px-4 sm:px-8 mb-16">
          <div className="text-center max-w-4xl mx-auto">
            <div className="hero-badge mx-auto mb-6">📄 Previous Year Questions</div>
            <h1 className="text-4xl lg:text-6xl font-extrabold gradient-text mb-6 leading-tight">PYQ of CUET</h1>
            <p className="text-xl text-text-muted mb-4">Download Previous Year Question Papers for CUET UG &amp; PG</p>
            <p className="text-text-muted mb-8">✅ Free PDFs &nbsp;•&nbsp; 📅 Latest Papers &nbsp;•&nbsp; ⚡ Instant Access</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button onClick={() => openGate('All CUET PYQs')} className="btn-primary px-8 py-4 text-lg font-bold rounded-xl">📥 Download CUET PYQs Now</button>
              <Link to="/register" className="px-8 py-4 text-lg font-bold rounded-xl border border-glass-border text-text-light hover:bg-white/5 transition-colors">Get Free Access</Link>
            </div>
            <p className="text-xs text-accent-gold mt-4">⚡ Free access available for limited time</p>
          </div>
        </div>

        {/* Download buttons */}
        <div className="max-w-[1400px] mx-auto px-4 sm:px-8 mb-16">
          <h2 className="text-3xl font-bold gradient-text text-center mb-10">Download CUET PYQs Instantly</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto">
            <div className="glass-card text-center">
              <div className="text-5xl mb-4">📘</div>
              <h3 className="text-xl font-bold text-text-light mb-3">CUET UG PYQs</h3>
              <p className="text-text-muted text-sm mb-2">• Language subjects</p>
              <p className="text-text-muted text-sm mb-2">• Domain subjects</p>
              <p className="text-text-muted text-sm mb-6">• General Test</p>
              <button onClick={() => openGate('CUET UG PYQs')} className="btn-primary w-full py-3 font-semibold rounded-xl">📥 Download CUET UG PYQs</button>
            </div>
            <div className="glass-card text-center">
              <div className="text-5xl mb-4">📗</div>
              <h3 className="text-xl font-bold text-text-light mb-3">CUET PG PYQs</h3>
              <p className="text-text-muted text-sm mb-2">• Subject-specific papers</p>
              <p className="text-text-muted text-sm mb-2">• Domain-wise question sets</p>
              <p className="text-text-muted text-sm mb-6">• Important topics coverage</p>
              <button onClick={() => openGate('CUET PG PYQs')} className="btn-primary w-full py-3 font-semibold rounded-xl">📥 Download CUET PG PYQs</button>
            </div>
          </div>
        </div>

        {/* Why download PYQs */}
        <div className="max-w-[1400px] mx-auto px-4 sm:px-8 mb-16">
          <h2 className="text-2xl font-bold gradient-text text-center mb-8">📊 Why Download PYQ of CUET?</h2>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 max-w-3xl mx-auto">
            {['Identify important topics', 'Understand question patterns', 'Improve accuracy & speed', 'Focus on high-weightage areas', 'Practice real exam-level questions', 'Smartest way to prepare'].map(b => (
              <div key={b} className="glass-card text-center p-4">
                <span className="text-green-400 text-xl block mb-2">✔</span>
                <p className="text-text-muted text-sm">{b}</p>
              </div>
            ))}
          </div>
        </div>

        {/* What you get */}
        <div className="max-w-[1400px] mx-auto px-4 sm:px-8 mb-16">
          <div className="glass-card max-w-3xl mx-auto">
            <h2 className="text-xl font-bold text-text-light mb-6">📚 What You Get in CUET PYQs</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {['Year-wise CUET question papers', 'Subject-wise organized PDFs', 'Easy-to-download format', 'Based on latest CUET exam pattern', 'Updated with recent exams', 'Covers all subjects & domains'].map(f => (
                <div key={f} className="flex items-center gap-3 p-3 bg-bg-secondary rounded-xl">
                  <span className="text-primary">→</span>
                  <span className="text-text-light text-sm">{f}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* How PYQs help */}
        <div className="max-w-[1400px] mx-auto px-4 sm:px-8 mb-16">
          <h2 className="text-2xl font-bold gradient-text text-center mb-8">How PYQs Help You Score Higher</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-3xl mx-auto">
            {['Improve exam strategy', 'Build confidence', 'Identify weak areas', 'Enhance time management'].map((b, i) => (
              <div key={b} className="glass-card text-center p-4">
                <div className="text-2xl font-bold text-primary mb-2">0{i + 1}</div>
                <p className="text-text-muted text-sm">{b}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Cross-sell */}
        <div className="max-w-[1400px] mx-auto px-4 sm:px-8 mb-16">
          <h2 className="text-2xl font-bold gradient-text text-center mb-6">Boost Your Preparation Further</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-3xl mx-auto">
            {[{ label: 'Free Mock Tests', href: '/test-zone', icon: '🧪' }, { label: 'Study Materials', href: '/study-materials', icon: '📚' }, { label: 'Self-Paced Courses', href: '/self-paced', icon: '🎥' }, { label: 'Counselling', href: '/cuet-counselling', icon: '🎓' }].map(l => (
              <Link key={l.label} to={l.href} className="glass-card text-center hover:border-primary/50 transition-colors p-4">
                <div className="text-3xl mb-2">{l.icon}</div>
                <div className="text-text-light text-sm font-semibold">{l.label}</div>
              </Link>
            ))}
          </div>
        </div>

        {/* FAQ */}
        <div className="max-w-[1400px] mx-auto px-4 sm:px-8 mb-16">
          <h2 className="text-2xl font-bold gradient-text text-center mb-8">Frequently Asked Questions</h2>
          <div className="max-w-3xl mx-auto space-y-4">
            {faqs.map((f, i) => (
              <details key={i} className="glass-card">
                <summary className="font-semibold text-text-light cursor-pointer list-none flex justify-between items-center">{f.q} <span className="text-primary text-xl">+</span></summary>
                <p className="text-text-muted mt-3 text-sm">{f.a}</p>
              </details>
            ))}
          </div>
        </div>

        <div className="max-w-[1400px] mx-auto px-4 sm:px-8">
          <div className="glass-card text-center max-w-3xl mx-auto">
            <h2 className="text-2xl font-bold text-text-light mb-3">Download PYQ of CUET &amp; Start Smart Preparation</h2>
            <p className="text-text-muted mb-2">Don't rely on guesswork — practice with real exam questions.</p>
            <p className="text-accent-gold text-sm mb-6">⚡ Limited free access available</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button onClick={() => openGate('All CUET PYQs')} className="btn-primary px-8 py-3 font-bold rounded-xl">📥 Download CUET PYQs Now</button>
              <Link to="/register" className="px-8 py-3 font-bold rounded-xl border border-glass-border text-text-light hover:bg-white/5 transition-colors">Register to Unlock Access</Link>
            </div>
          </div>
        </div>

        {/* Lead Gate Modal */}
        {gateOpen && (
          <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50 flex items-center justify-center p-4">
            <div className="bg-[#1a1a2e] border border-glass-border rounded-2xl w-full max-w-md p-6 shadow-2xl">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-xl font-bold text-text-light">📥 Download {pending}</h3>
                <button onClick={() => setGateOpen(false)} className="text-text-muted text-2xl">&times;</button>
              </div>
              <p className="text-text-muted text-sm mb-4">Quick registration to unlock your free download</p>
              <form onSubmit={handleSubmit} className="space-y-3">
                <input required placeholder="Full Name *" value={form.name} onChange={e => setForm({...form, name: e.target.value})}
                  className="w-full px-4 py-3 bg-bg-secondary border border-glass-border rounded-xl text-text-light focus:outline-none focus:border-primary" />
                <input required type="email" placeholder="Email Address *" value={form.email} onChange={e => setForm({...form, email: e.target.value})}
                  className="w-full px-4 py-3 bg-bg-secondary border border-glass-border rounded-xl text-text-light focus:outline-none focus:border-primary" />
                <input required type="tel" placeholder="Phone Number *" value={form.phone} onChange={e => setForm({...form, phone: e.target.value})}
                  className="w-full px-4 py-3 bg-bg-secondary border border-glass-border rounded-xl text-text-light focus:outline-none focus:border-primary" />
                <button type="submit" className="w-full btn-primary py-3 font-bold rounded-xl">📥 Get Download Link</button>
              </form>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default PYQCuetPage;
